



























































import {Component, Vue} from "vue-property-decorator";
import QuestionButtons from "@/resources/components/QuestionButtons.vue";
import Answer from '@/app/models/Answer';
//@ts-ignore
import VueSignaturePad from 'vue-signature-pad';
import TrashSvg from "@/assets/svg/trash.svg";
import UndoSvg from "@/assets/svg/undo.svg";
import Checklist from "@/app/models/Checklist";
import LoadingOverlay from "@/resources/components/LoadingOverlay.vue";
import Question from '@/app/models/Question';
import {AxiosError} from "axios";
import Station from "@/app/models/Station";
@Component({
    components: {QuestionButtons, TrashSvg, UndoSvg, LoadingOverlay,},
})
export default class Index extends Vue {
    checklist: Checklist | null = null;
    message: string = 'Vragenlijst is al beantwoord';

    $refs!: {
        signaturePad: VueSignaturePad,
    }

    get station(): Station|null {
        return this.$store.state.data.station;
    }

    get isScaffoldlessStation(): boolean {
        return this.station != null && this.station.is_scaffoldless_station === true;
    }

    beforeMount() {
        this.task(async () => {
            await Checklist.for(parseInt(this.$route.params.productionOrder), parseInt(this.$route.params.brand))
                .then((checklist: Checklist) => {
                    this.checklist = checklist;
                    this.checklist.questions.map((question: Question) => {
                        if (question.answer === null) {
                            question.answer = new Answer();
                        }
                        return question;
                    });
                })
                .catch((error: AxiosError) => {
                    if (error.response!.status === 422) {
                        this.checklist = null;
                    }
                    if (error.response!.status === 404) {
                        this.message = 'Er is geen tijdsregistratie in ISAH gevonden, voeg deze toe en probeer het daarna nog een keer.';
                    }
                    if (error.response!.status === 409) {
                        this.message = 'Er is vanuit ISAH geen station gevonden, voeg deze toe en probeer het daarna nog een keer.';
                    }
                });
        })
    }

    save() {
        if (this.checklist === null) {
            return false;
        }

        let signature = this.$refs.signaturePad.saveSignature();

        if (!this.validateFields(this.checklist, signature)) {
            return;
        }

        this.checklist.signature = signature.data;

        this.task(async () => await this.checklist!.save()).then(() => this.$router.replace({
            name: this.isScaffoldlessStation ? "projects.brands" : "production-orders.brands",
            params: this.isScaffoldlessStation ? {
                projectId: this.$route.params.projectId,
            } : {
                productionOrder: this.$route.params.productionOrder,
            },
        }));
    }

    partialSave() {
        if (this.checklist === null) {
            return false;
        }

        this.task(async () => await this.checklist!.partialSave()).then(() => {
            this.flash(this.$t('Checklist opgeslagen'));
        }).catch((error: AxiosError) => {
            if (error.response?.status !== 422) {
                this.flash(this.$t('Er is iets misgegaan bij het opslaan'));
            }
        });
    }

    validateFields(checklist: Checklist, signature: any) {
        if (checklist.questions.some((question: Question) => !question.is_header_text && question.answer!.value === null && question.image_only === false)) {
            this.flash(this.$t('Niet alle vragen zijn beantwoord'));
            return false;
        }

        let errors = checklist.questions.some((question: Question) => {
            if (question.is_header_text) {
                return false;
            }

            let requiredIsset = false;
            let requiredAnswers = false;

            for (let answer of ['yes', 'no', 'not_applicable']) {
                //@ts-ignore
                if (question[answer + '_required']) {
                    requiredAnswers = true;

                    if (question.answer!.value === answer) {
                        requiredIsset = true;
                    }
                }
            }

            if (!requiredIsset && requiredAnswers) {
                this.flash(this.$t('Vraag: "' + question.question + '" is niet juist beantwoord'));
                return true;
            }

            if (question.image_required && !question.answer!.image && !question.answer!.image_url) {
                this.flash(this.$t('Een afbeelding bij vraag: "' + question.question + '" is verplicht'));
                return true;
            }
        });

        if (errors) {
            return false;
        }

        if (signature.isEmpty) {
            this.flash(this.$t('Handtekening is verplicht'));
            return false;
        }

        return true;
    }

    resetSignaturePad() {
        this.$refs.signaturePad.clearSignature();
    }

    undoSignaturePad() {
        this.$refs.signaturePad.undoSignature();
    }
}
